export function inlineTaskResult(responseOk, payload = {}) {
  if (responseOk) {
    return {
      tone: "success",
      message: payload.message || "Saved. This task now reflects the updated fields."
    }
  }

  const errors = Array.isArray(payload.errors) ? payload.errors.filter(Boolean) : []
  return {
    tone: "error",
    message: errors.length > 0
      ? `Could not save: ${errors.join(". ")}`
      : "Could not save. Your changes are still here—try again."
  }
}
